import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Logo } from '@/shared/ui/Logo';

type AuthHeaderProps = {
  title: string;
  // Подзаголовок-вопрос со ссылкой опционален: экран успеха регистрации
  // показывает только заголовок (см. Register.tsx).
  questionText?: string;
  linkTo?: string;
  linkText?: string;
};

export const AuthHeader = ({ title, questionText, linkTo, linkText }: AuthHeaderProps) => {
  const { t } = useTranslation('auth');

  return (
    <>
      {/* Logo кликабелен, ведёт на индекс кабинета. Для гостя RequireAuth
          обработает и отправит на /login. У фронтендера Logo без обёртки —
          оборачиваем точечно в auth-флоу, чтобы не менять Logo в других
          местах. */}
      <Link to="/" aria-label={t('toHome')}>
        {/* Отступ под логотипом — токен темы (--auth-logo-gap). */}
        <Logo min={false} className="mb-auth-logo sm:mb-auth-logo-sm" />
      </Link>

      <div className="flex w-full flex-col gap-2 sm:items-center xl:items-start">
        <h1 className="text-content-auth-heading font-akzidenz text-[36px] font-medium leading-[45px] sm:text-[44px] sm:leading-[55px]">
          {title}
        </h1>
        {(questionText || (linkTo && linkText)) && (
          <div className="flex gap-2">
            {questionText && (
              <span className="text-content-auth-secondary sm:text-lg sm:leading-[22px]">
                {questionText}
              </span>
            )}
            {linkTo && linkText && (
              <Link to={linkTo}>
                <span className="text-content-auth-link hover:text-content-auth-link-hover cursor-pointer sm:text-lg sm:leading-[22px]">
                  {linkText}
                </span>
              </Link>
            )}
          </div>
        )}
      </div>
    </>
  );
};
